import React, { useState } from "react";
import { AgGridReact } from "ag-grid-react";

import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-alpine.css";


const ZoneGrid = ({ onSave }) => {
  const [zone, setZone] = useState({ name: "", description: "" });
  const [zones, setZones] = useState([]);
  const [editingRowIndex, setEditingRowIndex] = useState(null);

  const handleSave = () => {
    if (zone.name && zone.description) {
      if (editingRowIndex !== null) {
        // Update existing row
        const updatedZones = [...zones];
        updatedZones[editingRowIndex] = { ...zone }; // Update the selected row
        setZones(updatedZones);
        setEditingRowIndex(null); // Reset editing index
      } else {
        // Add new row
        setZones([...zones, { ...zone }]);
      }
      setZone({ name: "", description: "" }); // Reset form
      onSave(zone); // Call parent function
    }
  };

  const handleEdit = (params) => {
    const rowIndex = params.node.rowIndex;
    setZone({ ...zones[rowIndex] }); // Load selected row data into input fields
    setEditingRowIndex(rowIndex); // Store index for editing
  };


  const handleDelete = (params) => {
    const rowIndex = params.node.rowIndex;
    const updatedZones = zones.filter((_, index) => index !== rowIndex);
    setZones(updatedZones); // Remove row from state
    setEditingRowIndex(null); // Reset editing index if deleting an edited row
    setZone({ name: "", description: "" }); // Clear input fields if deleting an active edit
  };

  const columns = [
    { headerName: "Name", field: "name", flex: 1 },
    { headerName: "Description", field: "description", flex: 2 },
    {
        headerName: "Actions",
        field: "actions",
        cellRenderer: (params) => (
          <div className="d-flex gap-2">
            <button type="button" className="btn btn-sm btn-primary" onClick={() => handleEdit(params)}>Edit</button>
            <button type="button" className="btn btn-sm btn-danger" onClick={() => handleDelete(params)}>Delete</button>
          </div>
        ),
        flex: 1,
      },
  ];

  return (
    <div className="ag-theme-alpine mt-3" style={{ height: '100%' }}>
        <div className="mt-3 p-3 border rounded bg-light">
          <h6 className="text-secondary">Zone Details</h6>
          <div className="row">
            <div className="col-md-6">
              <label className="fw-semibold">Name</label>
              <input type="text" className="w-full px-3 py-2 shadow-md border border-gray-300 rounded-md focus:outline-none" value={zone.name} onChange={(e) => setZone({ ...zone, name: e.target.value })} />
            </div>
            <div className="col-md-6 mt-2">
              <label className="fw-semibold">Description</label>
              <input type="text" className="w-full px-3 py-2 shadow-md border border-gray-300 rounded-md focus:outline-none" value={zone.description} onChange={(e) => setZone({ ...zone, description: e.target.value })} />
            </div>
        </div>
        <button type="button" className="saveButton mt-3" onClick={handleSave}>{editingRowIndex !== null ? "Update" : "Save"}</button>
        </div>
        
      {/* <input type="text" className="form-control" placeholder="Name" value={zone.name} onChange={(e) => setZone({ ...zone, name: e.target.value })} />
      <input type="text" className="form-control" placeholder="Description" value={zone.description} onChange={(e) => setZone({ ...zone, description: e.target.value })} />
      <button onClick={handleSave}>Save Zone</button> */}
      {zones && zones.length > 0 &&
      <div className="ag-theme-alpine mt-5" style={{height: '300px'}}>
            <AgGridReact rowData={zones} columnDefs={columns} pagination={true} />
        </div>
        }
    </div>
  );
};

export default ZoneGrid;